import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	moveUp: {
		id: 'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.up.label',
		defaultMessage: 'Move up',
		description: 'Label of drag and drop menu item for moving card one placement up',
	},
	moveDown: {
		id: 'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.down.label',
		defaultMessage: 'Move down',
		description: 'Label of drag and drop menu item for moving card one placement down',
	},
	arrowUp: {
		id: 'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.up',
		defaultMessage: 'up',
		description: 'Icon label of drag and drop menu item for moving card one placement up',
	},
	arrowDown: {
		id: 'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.down',
		defaultMessage: 'down',
		description: 'Icon label of drag and drop menu item for moving card one placement down',
	},
	reorder: {
		id: 'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.reorder',
		defaultMessage: 'reorder',
		description: 'Label of drag handle button',
	},
});
